import {getBridgeSDK, isInApp} from "../bridge/bridge_sdk";
import {GetAppVersion, IsBeforeTargetVersion} from "./utils";

const BridgeHelper = {
	showToast(title) {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().showToast(title)
		} else {
			alert(title)
		}
	},

	showSpinner(key)   {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().showSpinner(key)
		} else {
			//
		}
	},

	hideSpinner(key)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().hideSpinner(key)
		} else {
			//
		}
	},

	pushPage(page, title, passProps, hideNavBar)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().pushPage(page, title, passProps, hideNavBar)
		} else {
			//
		}
	},

	popPage(param)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().popPage(param)
		} else {
			//
		}
	},

	modalPage(page, title, passProps, hideNavBar)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().modalPage(page, title, passProps, hideNavBar)
		} else {
			//
		}
	},

	dismissPage(param)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().dismissPage(param)
		} else {
			//
		}
	},

	showOverlay(page, passProps)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().showOverlay(page, passProps)
		} else {
			//
		}
	},

	dismissOverlay()  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().dismissOverlay()
		} else {
			//
		}
	},

	switchToTab(index, timeout=0)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().switchToTab(index, timeout)
		} else {
			//
		}
	},

	showActionSheet(onClick)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().showActionSheet(onClick)
		} else {
			//
		}
	},

	showPopUp(title, list, onClick)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().showPopUp(title, list, onClick)
		} else {
			//
		}
	},

	/**
	 * @Desc
	 * @Params mode: date | time | datetime; initialDate: YYYY-MM-DDTHH:mm:ss
	 * @Return
	*/
	showDatePicker(mode, initialDate, onClick)  {
		if (isInApp) {
			const options = {
				mode: mode,
				initialDate: initialDate,
			}
			getBridgeSDK() && getBridgeSDK().showDatePicker(options, onClick)
		} else {
			//
		}
	},

	//需要添加版本判断， <=线上版本， 保持不变； >线上版本， 全部改为使用withURL
	executeRequest(apiPath, params, success, fail)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().executeRequest(apiPath, params, success, fail)
		} else {
			//
		}
	},

	executeRequestWithUrl(url, params, success, fail){
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().executeRequestWithUrl(url, null, "POST", params, success, fail)
		} else {
			//
		}
	},

	phoneCall(phoneNumber)   {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().phoneCall(phoneNumber)
		} else {
			//
		}
	},

	sendEmail(emailList, subject, body)   {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().sendEmail(emailList, subject, body)
		} else {
			//
		}
	},

	logInfo(...data)   {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().logInfo(...data)
		} else {
			//
		}
	},

	openQRCodeScanner(title, passProps, success, fail)   {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().openQRCodeScanner(title, passProps, success, fail)
		} else {
			//
		}
	},

	incompatibleSDK()  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().incompatibleSDK()
		} else {
			//
		}
	},

	openInBrowser(link)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().openInBrowser(link)
		} else {
			window.open(link)
		}
	},

	saveToCache(key, data, success, fail)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().saveToCache(key, data, success, fail)
		} else {
			//
		}
	},

	loadFromCache(key, success, fail)  {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().loadFromCache(key, success, fail)
		} else {
			//
		}
	},

	removeFromCache(key) {
		if (IsBeforeTargetVersion('1.6.125', GetAppVersion())) {
			return
		}
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().removeFromCache(key)
		} else {
			//
		}
	},

	getToken(success, fail) {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().getToken(success, fail)
		} else {
			//
		}
	},

	refreshToken(success, fail) {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().refreshToken(success, fail)
		} else {
			//
		}
	},

	popToRoot() {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().popToRoot()
		} else {
			//
		}
	},
	addReminderToCalendar(reminderKey, title, content) {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().addReminderToCalendar(reminderKey, title, content)
		} else {
			//
		}
	},

	shareUrl(url, title, message) {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().shareUrl(url, title, message)
		} else {
			//
		}
	},
	shareImage(img_base64, title, message) {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().shareImage(img_base64, title, message)
		} else {
			//
		}
	},

	getPosition(success, fail) {
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().getPosition(success, fail)
		} else {
			//
		}
	},

	grayLogEvent(eventName, additionalInfo) {
		if (IsBeforeTargetVersion('1.6.111', GetAppVersion())) {
			return
		}
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().grayLogEvent(eventName, additionalInfo)
		} else {
			//
		}
	},

	grayLogNetwork(api, parameters, statusCode, errMsg, additionalInfo) {
		if (IsBeforeTargetVersion('1.6.111', GetAppVersion())) {
			return
		}
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().grayLogNetwork(api, parameters, statusCode, errMsg, additionalInfo)
		} else {
			//
		}
	},

	grayLogError(error, additionalInfo) {
		if (IsBeforeTargetVersion('1.6.111', GetAppVersion())) {
			return
		}
		if (isInApp) {
			getBridgeSDK() && getBridgeSDK().grayLogError(error, additionalInfo)
		} else {
			//
		}
	}
}

export {
	BridgeHelper
}
